<template>
  <div class="store-info-container">
    <!-- 上半部分：小程序应用配置 -->
    <AppConfigSection @app-selected="handleAppSelected" />

    <!-- 下半部分：门店列表 -->
    <StoreListSection :selected-app-id="selectedAppId" />
  </div>
</template>

<script>
import AppConfigSection from './components/AppConfigSection.vue';
import StoreListSection from './components/StoreListSection.vue';

export default {
  name: 'StoreInfo',
  components: {
    AppConfigSection,
    StoreListSection
  },
  data() {
    return {
      selectedAppId: null
    };
  },
  methods: {
    handleAppSelected(appid) {
      this.selectedAppId = appid;
    }
  }
};
</script>

<style scoped lang="less">
.store-info-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #f5f5f5;
}
</style>
